import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  COMMON_FEATURE_KEY,
  State,
  CommonPartialState
} from './common.reducer';

// Lookup the 'Common' feature state managed by NgRx
export const getCommonState = createFeatureSelector<CommonPartialState, State>(
  COMMON_FEATURE_KEY
);

export const getEditMode = createSelector(
  getCommonState,
  (state: State) => state.editMode
);

export const getDefaultFilters = createSelector(
  getCommonState,
  (state: State) => state.defaultFilters
);
